export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TabCreazioneNota.vue?vue&type=template&id=2bb211f9&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabCreazioneNota.vue?vue&type=template&id=2bb211f9&
// module id = 721
// module chunks = 0